import { Routes } from '@angular/router';
import { CheckoutComponent } from './pages/checkout/checkout.component';
import { ProductDetailsComponent } from './pages/product-details/product-details.component';
import { RatingsComponent } from './pages/ratings/ratings.component';
import { SuccessComponent } from './pages/success/success.component';
import { BnplCallbackComponent } from './pages/checkout/payment/bnpl-callback/bnpl-callback.component';
import { HomeComponent } from './pages/home/home.component';

export const routes: Routes = [
  {
    path: 'stores/:name',
    component: HomeComponent,
  },
  {
    path: 'stores/:name/cart',
    component: CheckoutComponent,
    title: 'Cart',
  },
  {
    path: 'stores/:name/ratings',
    component: RatingsComponent,
  },
  {
    path: 'stores/:name/payment-success',
    component: SuccessComponent,
  },
  {
    path: 'stores/:name/stanbicbnpl-success',
    component: BnplCallbackComponent,
  },
  {
    path: 'stores/:name/:id',
    component: ProductDetailsComponent,
  },
  {
    path: '**',
    redirectTo: '',
  },
];
